<header>
    <nav class="main-navigation navbar navbar-default navbar-fixed-top">
        <div class="container">
            <div class="row">
                <div class="col-xs-12">
                    <div class="navbar-wrapper">
                        <div class="navbar-header">
                            <button type="button" data-toggle="collapse" data-target="#navbar" class="navbar-toggle">
                                <span class="sr-only">Navigation ein-/ausblenden</span><span
                                    class="icon-bar"></span><span class="icon-bar"></span><span class="icon-bar"></span>
                            </button>
                            <a href="#" class="navbar-brand">
                                <!--Alexander Koenig-->
                                <img src="/assets/svg/logo.svg" alt="Alexander Koenig" class="logo js-logo">
                                <!--span(class="subheadline") Senior Frontend Developer & Fotograf--></a>
                        </div>
                        <div id="navbar" class="collapse navbar-collapse">
                            <ul class="nav navbar-nav">
                                <li><a routerLink="aboutme" routerLinkActive="active" tabindex="0">Über mich</a></li>
                                <li class="sub-menu">
                                    <a routerLink="photography" routerLinkActive="active" tabindex="0">Fotografie</a>

                                </li>
                                <li><a routerLink="references" routerLinkActive="active" tabindex="0">Referenzen</a>
                                </li>
                                <li><a routerLink="contact" routerLinkActive="active" tabindex="0">Kontakt</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</header>
